import { Config } from '../config';

export const isNotDev = () => window.location.hostname !== 'localhost';

// US production: 'us' is new, 'beta' is deprecated but still functional
export const isUSprod = () => isNotDev() && (Config.StageName === 'us' || Config.StageName === 'beta');

export const isNotUSprod = () => !isUSprod();

export const isStaging = () => isNotDev() && Config.StageName === 'staging';

export const isTest = () => isNotDev() && Config.StageName === 'test';

export const isEUpilot = () => isNotDev() && Config.StageName === 'eupilot';

export const isEUprod = () => isNotDev() && (Config.StageName === 'euprod' || Config.StageName === 'eu');

export const isUKprod = () => isNotDev() && (Config.StageName === 'ukprod' || Config.StageName === 'uk');

export const isNotProd = () => !isEUpilot() && !isEUprod() && !isUSprod() && !isUKprod();
